import { render, staticRenderFns } from "./Seachview.vue?vue&type=template&id=8cf20b2a&scoped=true&"
import script from "./Seachview.vue?vue&type=script&lang=js&"
export * from "./Seachview.vue?vue&type=script&lang=js&"
import style0 from "./Seachview.vue?vue&type=style&index=0&id=8cf20b2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf20b2a",
  null
  
)

export default component.exports